import React from "react";
import { FormBadge, formulationLine } from "./FormBadge";

/**
 * PDP right-column header block — SKU, format badge, product name,
 * formulation line, and status badges (RUO / in-stock).
 * Structural extraction from ProductDetail.jsx.
 */
export function ProductInfo({ product, canAdd }) {
  return (
    <div>
      <div className="flex items-center gap-2 mb-2">
        <div className="text-[11px] font-semibold uppercase tracking-[0.2em] text-brand-muted">
          {product.public_sku}
        </div>
        <FormBadge format={product.format} />
      </div>
      <h1 className="font-display text-3xl md:text-4xl font-bold tracking-tight text-brand-navy leading-tight">
        {product.product_name}
      </h1>
      <div className="mt-3 text-[15px] text-brand-muted font-medium" data-testid="pdp-formulation-line">
        {formulationLine(product)}
      </div>

      {/* Badges */}
      <div className="mt-5 flex flex-wrap gap-1.5">
        <span className="inline-flex items-center gap-1 px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.14em] text-amber-800 bg-amber-50 border border-amber-200 rounded-full">
          Research Use Only
        </span>
        {canAdd && (
          <span className="inline-flex items-center gap-1 px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.14em] text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-full">
            In Stock
          </span>
        )}
      </div>
    </div>
  );
}
